import type {
  LandlordJoinWaitlistResponseFailure,
  LandlordPortfolioSize,
} from '@/hooks/__generated__/useWaitlist_Mutation.graphql';

export const portfolioSizes: {
  label: string;
  value: LandlordPortfolioSize;
}[] = [
  { label: '1', value: 'ONE' },
  { label: '2–5', value: 'TWO_TO_FIVE' },
  { label: '6–20', value: 'SIX_TO_TWENTY' },
  { label: '20+', value: 'TWENTY_PLUS' },
];

/** Matches the API `INVALID_POSTCODE_AREA` length cap. */
export const postcodeAreaMaxLength = 8;

/** API failures plus client-side verification and unrecognised errors. */
export type WaitlistError =
  LandlordJoinWaitlistResponseFailure | 'VERIFICATION_FAILED' | 'UNKNOWN';

export const getWaitlistErrorMessage = (error: WaitlistError): string => {
  switch (error) {
    case 'INVALID_EMAIL':
      return 'Enter a valid email address.';
    case 'INVALID_POSTCODE_AREA':
      return 'Enter a valid postcode area, e.g. SW11.';
    case 'VERIFICATION_FAILED':
      return 'Please complete the check and try again.';
    default:
      return 'Something went wrong. Please try again.';
  }
};

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string) => emailPattern.test(email.trim());

export const isValidPostcodeArea = (postcodeArea: string) => {
  const trimmed = postcodeArea.trim();
  return trimmed.length > 0 && trimmed.length <= postcodeAreaMaxLength;
};

export const isHumanVerificationError = ({ message }: { message: string }) =>
  message.toLowerCase().includes('human verification');
